import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { BleRemoteApi } from "./ble-remote-api";
import { MockRemoteApi } from "./remote-api";
import { WebBleTransport } from "./transport";
import "./styles.css";
import { captureEnrollmentFragment } from "./auth";

const mockMode = new URLSearchParams(window.location.search).get("mock") === "1";
if (!mockMode) {
  try {
    captureEnrollmentFragment();
  } catch (error) {
    console.warn("Ignored invalid controller enrollment link", error);
  }
}
const api = mockMode ? new MockRemoteApi() : new BleRemoteApi(new WebBleTransport());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App api={api} mockMode={mockMode} />
  </StrictMode>,
);
